$(document).ready(function(){

	// store filter per group
	var filters = {};

	var isotopeSettings = {
	  itemSelector: '.grid-item',
	  layoutMode: 'masonry',
	  percentPosition: true,
	  masonry: {
	    columnWidth: '.grid-sizer',
	    marginBottom: 20
	  }
	};

	// -- Init Isotope --
	var $grid = $('.grid').isotope(isotopeSettings);
	// -- Init Isotope after each image loads --
	$grid.imagesLoaded().progress( function() {
	  $grid.isotope('layout');
	});

	// Filter with checkboxes
	$('.filterByDate, .filterByCat').on('change', function(event) {
	  var checkbox = event.target;
	  var $checkbox = $(checkbox);
	  var group = $checkbox.parents('.option-set').attr('data-group');
	  // create array for filter group, if not there yet
	  var filterGroup = filters[group];
	  if (!filterGroup) {
	    filterGroup = filters[group] = [];
	  }
	  // add/remove filter
	  if (checkbox.checked) {
	    // add filter
	    filterGroup.push(checkbox.value);
	  } else {
	    // remove filter
	    var index = filterGroup.indexOf(checkbox.value);
	    filterGroup.splice(index, 1);
	  }

	  var comboFilter = getComboFilter();
	  $grid.isotope({ filter: comboFilter });

	});

	// Init select filter
	var defaultSelectedValue = $('.selectFilter option[selected]').val();
	$('.grid__filterBySelect').isotope({filter: defaultSelectedValue});

	// Filter with a select
	$('.selectFilter').on( 'change', function() {
	  var filterValue = this.value;
	  $grid.isotope({ filter: filterValue });
	});

	// -- Reload isotope on summary open --
	$('.grid-item summary').on('click', function(){
		setTimeout(function(){
			$grid.isotope('layout');
		},100);
	});

	
	// -- Smooth scroll after filter (mobile) --
	$('.checkbox__container .filter').on('touchend', function(){
		var input = $(this).find('input');
		var gridOff = $('.grid').offset().top;
		var scrollTop = $('.main__container').scrollTop();
		var scrollTopResult = scrollTop+gridOff - 24;
		if (!input.is(':checked')) {
			$('.main__container').animate({
				scrollTop: scrollTopResult
			}, 'slow');
		}

	});



	function getComboFilter() {
	  var combo = [];
	  for (var prop in filters) {
	    var group = filters[prop];
	    if (!group.length) {
	      // no filters in group, carry on
	      continue;
	    }
	    // add first group
	    if (!combo.length) {
	      combo = group.slice(0);
	      continue;
	    }
	    // add additional groups
	    var nextCombo = [];
	    // split group into combo: [ A, B ] & [ 1, 2 ] => [ A1, A2, B1, B2 ]
	    for ( var i=0; i < combo.length; i++ ) {
	      for ( var j=0; j < group.length; j++ ) {
	        var item = combo[i] + group[j];
	        nextCombo.push( item );
	      }
	    }
	    combo = nextCombo;
	  }
	  var comboFilter = combo.join(', ');
	  return comboFilter;
	}

	
});
